module.exports = __webpack_public_path__ + "img/icon-valuation.f385bbba.svg";